import styled from "styled-components";
import { colors } from "../../../theme";

const Page = styled.div.withConfig({
  displayName: "Page",
})`
  background: ${colors.black};
`;

export default Page;
